import React from 'react';
import { motion } from 'framer-motion';
import { KoaTestimonial } from '../components/landing/KoaTestimonial';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { HeroSection } from '../components/landing/HeroSection';

export const KoaPage: React.FC = () => {
  return (
    <div className="space-y-24">
      <KoaTestimonial />
      <HeroSection />
      <div className="mt-24">
        <FeaturesSection />
      </div>
    </div>
  );
};